import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import Moment from 'moment';
import { ISubjectBuilderMoveOptions } from '@/courses/interfaces/subject-builder.interfaces';

@Component({})
export default class EdMoveLessonsModal extends Vue {

  @Prop({ required: true }) params: any;

  public changeSelected = null;

  get targetLessonSelected () {
    return this.params.targetLessonSelected;
  }

  get srcLessonSelected () {
    return this.params.srcLessonSelected;
  }

  get prevLessonDates () {
    return this.params.prevLessonDates;
  }

  get moveType () {
    return this.params.moveType;
  }

  get moveLabels(): ISubjectBuilderMoveOptions {
    const isToNotContent = this.targetLessonSelected?.rootType !== 'CONTENT';
    const optionSublabelB = isToNotContent ? 'optionSublabelBToNotContent' : 'optionSublabelB';

    return {
      optionA: {
        label: this.getOptionLabel('optionLabelA'),
        sublabel: this.getOptionLabel('optionSublabelA'),
      },
      optionB: {
        label: this.getOptionLabel('optionLabelB'),
        sublabel: this.getOptionLabel(optionSublabelB),
      },
      optionC: {
        label: this.getOptionLabel('optionLabelC')
      }
    }
  }

  getOptionLabel(labelOption: string): string {
    return this.$i18n.t(`courses.subjectBuilder.movements.${this.moveType}.${labelOption}`, { 
      from: this.srcLessonSelected?.name,
      to: this.targetLessonSelected?.name,
      dateFrom: Moment(this.prevLessonDates?.schoolDate).format('MMM Do')
    }).toString()
  }

  doMoveLessons() {
    this.params.moveLessons(this.changeSelected);
    this.$EdModal.closeModal();
  }

  doCancelMovement() {
    this.params.onCancelMovement();
    this.$EdModal.closeModal();
  }

}